export const APP_NAME = process.env.REACT_APP_APP_NAME || "Airava";
export const APP_TAGLINE = process.env.REACT_APP_APP_TAGLINE || "Work flows clearly.";
export const BRAND_ICON = "/airava-icon.png";
export const BRAND_LOGO = "/airava-logo.png";
export const BRAND_LOGO_WHITE = "/airava-logo-white.png"; // "Logo Bianco" — white logo, transparent bg
export const BRAND_WORDMARK = "/airava-wordmark.png";
export const BRAND_SKY = "/airava-sky.jpg";

// Airava brand tokens (kept in sync with CSS variables in index.css)
export const BRAND = {
  skyBlue: "#3B82F6",
  cloudBlue: "#93C5FD",
  skyMist: "#EAF4FF",
  cloudWarm: "#FFF8ED",
  slate: "#1F2937",
  primary: "#2563EB",
  primaryHover: "#1D4ED8",
};
